import React, { Component } from "react";
import { graphql } from "react-apollo";
import _ from "lodash";

// Components
import UserDetailsForm from "./UserDetailsForm";

// Query
import query from "../../queries/fetchUserById";

// Mutation
import mutation from "../../mutations/editUserDetails";

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      fetching: false
    };
    this.getStateFromChild = this.getStateFromChild.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.successMsg = this.successMsg.bind(this);
  }
  getStateFromChild(state) {
    const cleanState = _.omit(state, "errs");
    this.handleSubmit(cleanState);
  }
  successMsg() {
    this.setState({
      msg: "Se editó correctamente."
    });
    setTimeout(() => this.setState({ msg: "" }), 3000);
  }
  handleSubmit(payload) {
    const options = {
      userId: this.props.match.params.id,
      action: "edit"
    };
    this.setState({
      fetching: true
    });
    this.props
      .mutate({
        variables: { ...payload, ...options }
      })
      .then(() => this.props.data.refetch())
      .then(() => this.successMsg())
      .then(() => this.setState({ fetching: false }));
  }
  render() {
    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }
    return (
      <div className="container">
        <br />
        <h1>Detalles del usuario</h1>
        <br />
        <UserDetailsForm
          sendStateToParent={this.getStateFromChild}
          userId={this.props.match.params.id}
          hideBtn={this.state.fetching}
        />
        <br />
        {this.state.msg === "" ? null : (
          <div className="alert alert-success">{this.state.msg}</div>
        )}
        <br />
        <br />
      </div>
    );
  }
}

export default graphql(mutation)(
  graphql(query, {
    options: props => {
      return { variables: { id: props.match.params.id } };
    }
  })(EditProfile)
);



// WEBPACK FOOTER //
// ./src/components/User/EditUser.js